import { BASE_URL } from 'global/utils/ApiService';

const endpointUrls = {
  //Base Url

  //igtTest
  baseUrl: BASE_URL,

  //Map
  mapSearchGetAll: 'https://map.ir/search/autocomplete',

  //A
  addressGetAll: '/v2/PeopleAddress/BriefGetPeopleAddress',
  addressDelete: (id: number | string) => '/v2/PeopleAddress/' + id,
  addressMakeDefault: '/v2/PeopleAddress/SetDefaultAddress',
  addressGetDetail: (id: number | string) => '/v2/PeopleAddress/' + id,
  addressUpdate: '/v2/PeopleAddress',
  addressCreate: '/v2/PeopleAddress/CreatePeopleAddressForOM',
  clientAddressCreate: '/v2/PeopleAddress/CreatePeopleAddressForOM',
  addressChangePeopleType: '/v2/PeopleAddress/ChangePeopleAddressType',
  peopleAddressGetCustomerLinkLocationsFromJet: '/v2/PeopleAddress/GetCustomerLinkLocationsFromJet',

  //B
  //bank
  bankGetAll: '/v2/Bank/Search',
  bankAccountTypeGetAll: '/v2/BankAccountType/getall',
  BranchesBriefListGetAll: '/v2/Branches/GetAllBranchesBriefList',

  //branches
  branchesGetAll: '/v2/branches/search',
  branchesGetAllPublic: '/v2/branches/PublicSearch',
  getPudoBranches: '/v2/Branches/GetPudoBranches',

  //branchWorkingTime
  branchesWorkingTimesForOrder: '/v2/BranchesWorkingTimes/GetPickupPeriodsForOrder',

  //C
  //city
  cityGetALL: '/v2/City/GetAllWithoutSearch',
  cityGetAll: '/v2/City/PublicGetAllForEtipax',
  cityGetAllPublic: '/v2/City/PublicGetAllForEtipax',
  customerCategoryGetAll: '/v2/customerCategory/search',
  customerGetAll: '/v2/customer/OmGetCustomers',
  omCustomerGetAll: '/v2/customer/OmGetCustomersBrief',
  customerCreate: '/v2/customer',
  customerActualCreate: '/v2/customer/CreateActualCustomer',
  customerLegalCreate: '/v2/customer/CreateLegalCustomer',
  customerBankAccountEdit: '/v2/PersonBankAccount/UpdateCustomerbankAccount',
  customerBankAccountDelete: (id: number | string) => '/v2/PersonBankAccount/DeleteCustomerBankAccount/' + id,
  //client
  clientDelete: (id: number | string) => '/v2/client/' + id,
  clientCreate: '/v2/client',
  clientGetAll: '/v2/client/Search',
  clientGetDetail: (id: number | string) => '/v2/client/' + id,
  clientUpdate: '/v2/client',
  //contractAmount
  contractAmount: '/v2/Jet/DashboardContractAmount',
  contractAmountPublic: '/v2/Jet/PublicDashboardContractAmount',
  //contractInvalidate
  contractInvalidateCheckingGet: '/v2/ParcelInvalidation/InvalidateChecking',
  //customerPackaging
  customerPackageConfirmationGetAll: '/v2/CustomerPackage/Search',
  customerPackageConfirmation: '/v2/CustomerPackage/ConfirmPackage',
  customerPackageReject: '/v2/CustomerPackage/RejectPackage',
  customerPackageDetail: (id: string | number) => '/v2/CustomerPackage/' + id,
  customerPackageDelete: (id: string | number) => '/v2/CustomerPackage/' + id,
  customerPackagingConfirmationTypeGetAll: '/v2/CustomerPackagingConfirmation/GetAll',
  //customerUser
  customerUserSearch: '/v2/CustomerUser/Search',
  customeDashboardGetAll: '/v2/Customer/OmGetAllCustomerDashboardStats',
  customerGetDetail: (id: number | string | undefined) => '/v2/customer/' + id,
  customerCustomPackagingPriceGetAll: '/v2/CustomPackagingPrice/getMyCustomPackages',
  customerFinancialInfo: '/v2/Customer/OmGetMyCustomersWithFinancialInfo',
  myCustomerClientGetAll: '/v2/CustomerClient/GetMyClients',

  //customerPromotionList
  customerPromotionList: '/v2/customerPromotion/Search',

  //customerPickuperBranch
  customerPickuperBranchGetAll: '/v2/CustomerPickuperBranch/Search',
  //customerOmFinancialExcel
  customerFinancialExcel: '/v2/Customer/OmGetCustomersWithFinancialInfoForExcel',
  //D
  //DefaultText
  defaultTextGetAll: '/v2/DefaultText/Search',
  defaultTextDelete: '/v2/DefaultText',
  defaultTextCreate: '/v2/DefaultText',
  defaultTextUpdate: '/v2/DefaultText',
  //deliveryType
  deliveryTypeGetAll: '/v2/DeliveryType/Search',

  //t
  nextDaySeriveTimeTable: '/v2/TimeTable/GetNextDayTimeTableSchedule',

  //F
  forgetPasswordGenerateCodeByEmail: '/v2/Users/GenerateCodeForForgetingPasswordByEmail',
  forgetPasswordChangePasswordByEmail: '/v2/Users/ForgetPasswordByEmail',
  forgetPasswordResendCodeByEmail: '/v2/Users/ResendCodeForForgetingPasswordByEmail',

  //v
  //voucher
  voucherGetAll: '/v2/Voucher/GetMyCustomerVouchers',
  voucherPersonTotalBalanceGetAll: '/v2/Voucher/GetPersonTotalBalance',
  voucherGetMyCustomerInvoices: '/v2/Voucher/GetMyCustomerInvoices',
  voucherPaymentTypeGetAll: '/v2/VoucherPaymentType/GetAll',
  voucherCreditOperation: '/v2/Voucher/CreditOperation',
  myVoucherGetAll: '/v2/Voucher/GetMyVouchers',
  voucherRechargeWallet: '/v2/Voucher/RechargeWallet',
  voucherCustomerGetForExcel: '/v2/Voucher/GetMyCustomerVouchersForExcel',
  verifyBankTransaction: '/v2/Voucher/VerifyBankTransaction',
  //payment
  verifyPayment: '/v2/Order/OmVerifyFinancialOfOrder',

  //L
  //locker
  lockerSearchKiosks: '/v2/Locker/SearchKiosks',
  lockerInsertOrder: '/v2/Locker/InsertOrder',
  lockerInqueryKiosk: '/v2/Locker/InquiryKiosk',
  lockerInqueryBunch: '/v2/Locker/InquiryBunch',
  lockerSearchBunch: '/v2/Locker/SearchBunches',
  lockerInsertNearestOrder: '/v2/Locker/InsertNearestOrder',

  //LTL
  ltlSourceCitiesGetAll: '/v2/LtlOrder/GetSourceCities',
  ltlDestinationCities: '/v2/LtlOrder/GetDestinationCities',
  ltlPalletValidation: '/v2/PackagingType/GetPalletPackage',
  submitLtlOrder: '/v2/Booking/Register',
  lTLEditByCustomer: '/v2/Booking/UpdateByCustomer',
  ltlGetWorkingDate: '/v2/Booking/GetWorkingDates',
  ltlOrderGetPalletDetails: '/v2/LtlOrder/GetPalletDetails',
  lTLExcelGetAllOrders: '/v2/Booking/GetAllForExcel',

  //M
  MapIrGetAddressFast: (lat: string | number, long: string | number) => `https://map.ir/reverse/fast-reverse?lat=${lat}&lon=${long}`,
  MapIrGetAddress: (lat: string | number, long: string | number) => `https://map.ir/reverse?lat=${lat}&lon=${long}`,
  MapIrSearchAutocomplete: (text: string) => `https://map.ir/search/v2/autocomplete?text=${encodeURIComponent(text)}`,

  //N
  //notification
  notificationListGetAll: '/v2/Notification/Search',
  myNotificationsGetAll: '/v2/Notification/GetMyNotifications',
  notificationCreate: '/v2/Notification',
  notificationUpdate: '/v2/Notification',
  notificationsAsReadSetMarkAll: '/v2/Notification/MarkAllNotificationsAsRead',
  setMarkAllNotificationsAsRead: '/v2/Notification/MarkAllNotificationsAsRead',

  //O
  //OrderSubmit
  getParcelType: '/v2/ParcelType/Search',
  getPackingType: '/v2/PackagingType/PublicGetAll',
  submitOrder: '/v2/Order/OmOrderRegister',
  submitPreOrder: '/v2/Order/RegisterPreOrders',
  submitOrderForBranch: 'OM/v4/OmOrder/WithClientAndAddress',
  omV4Pricing: 'OM/v4/Pricing',
  orderInvalidate: '/v2/Order/OmInvalidateOrder',
  preOrderCancelation: '/v2/order/cancelPreOrder',

  submitUnPaidOrder: (orderId: number) => '/v2/Order/CompleteOrderOperation?orderId=' + orderId,
  getParcelsInStatusReport: '/v2/ParcelReport/GetParcelsInStatusReport',
  //orderManagementPrice
  orderManagementPricing: 'http://212.33.205.90:262/api/v2/Pricing',
  orderGetAll: '/v2/Order/OmGet',
  orderGetFullList: '/v2/Order/OmGetFullList',
  orderLtlCustomerGet: '/v2/Booking/Search',
  orderGetLocker: (orderId: string | number) => `/v2/Order/OmGetLockerDetail?orderId=${orderId}`,
  orderGetStatistics: (orderId: string | number) => `/v2/Order/OmGetOrderStatestic?orderId=${orderId}`,
  orderGetOrderSendersAndReceivers: (orderId: string | number) => `/v2/Order/OmGetOrderSendersAndReceivers?orderId=${orderId}`,
  orderGetJetLogs: (orderNumber: string | number) => `/v2/Order/OmGetJetLogs?orderNumber=${orderNumber}`,
  orderGetContract: (orderId: string | number) => `/v2/Order/OmGetOrderContracts?orderId=${orderId}`,
  orderReturnRegister: '/v2/Order/RegisterReturnOrder',
  orderReturnFinancial: '/v2/Order/OmGetReturnOrderFinancial',
  orderGetContractDetail: (orderId: string | number) => `/v2/Order/OmGetOrderContractDetail?id=${orderId}`,
  orderContractParcelsDetail: (parcelId: string | number) => `/v2/Order/OmGetOrderContractParcelsDetail?id=${parcelId}`,
  orderCancelContract: '/v2/Order/InvalidateOrderCost',
  orderLTLReject: '/v2/Booking/Reject',
  orderLTLCancel: '/v2/Booking/Cancel',

  orderDelete: '',
  OrderStatusGetAll: '/v2/OrderStatus/Search',
  OmOrdersNotInParcelManagmentGetAll: '/v2/Order/OmGetOrdersNotInParcelManagment',
  orderDetail: '/v2/Order/OmOrderDetail',
  orderBriefGetAll: '/v2/Order/BriefGetAll',
  orderFinancial: '/v2/Order/omGetFinancialOfOrder',
  preOrderFinancial: '/v2/Order/OmGetFinancialOfPreOrder',
  orderFinancialV4: '/OM/v4/pricing',

  orderFinancialPricing: '/OM/v3/Pricing',
  orderTacking: '/v2/Tracking/OmGetTrackingDetail',
  orderOmGetAll: '/v2/Order/OmGetAll',
  orderOmStatusGetAll: '/v2/OrderStatus/OmStatusGetAll',
  assignOrderToBranches: '/v2/ParcelOperator/AssignParcelToPickupBranch',
  orderdetailWithContractCodeGetAll: '/v2/Order/OmOrderDetailWithContractCode',
  contractInvalidateCheckingGetAll: '/v2/ParcelInvalidation/InvalidateChecking',
  orderDetailWithContractCodeGetAll: '/v2/Order/OmOrderDetailWithContractCode',
  orderFinancialStatusGetAll: '/v2/OrderFinancialStatus/Search',
  orderingBulkByExcel: '/OM/v3/Orders/GroupOrder',
  dowloadTemplateExcelForBulkOrder: '/v2/BulkOrders/DownloadTemplateExcelForBulkOrder',
  checkNationalCodeForBulkOrders: '/v2/Order/CheckNationalCodeForBulkOrders',
  orderServiceGetAll: '/v2/Service/Search',
  omQueueOrderRegister: '/v2/Order/OmQueueOrderRegister',
  omGetProcessParcels: '/v2/Order/OmGetProcessParcels',

  getJetTrackingDetail: '/v2/Tracking/GetJetTrackingDetail',
  //P
  //Profile
  getMyBusinessProfile: '/v2/Customer/GetMyCustomerBusinessProfile',
  updateMyBusinessProfile: '/v2/Customer/UpdateBusinessProfile',
  changeApiKey: '/v2/Customer/ChangeApiKey',
  //parcel
  parcelOmDetail: '/v2/Parcel/OmParcelDetail',
  preOrderChangeRecieverAddress: '/v2/PeopleAddress/CreateAddressForPreOrderFromJet',
  parcelInvalidateWithContractCode: '/v2/ParcelInvalidation/InvalidateWithContractCode',
  parcelCancellationTypeGetAll: '/v2/ParcelCancelationType/GetAll',
  getAllParcelStatus: '/v2/ParcelStatus/GetAll',
  parcelOmGetAll: '/v2/Parcel/OmGetAll',
  parcelOmGet: '/v2/Parcel/OmGet',
  parcelStatusOmGetAll: '/v2/ParcelStatus/OmStatusGetAll',
  parcelGetAllForPrint: '/v2/Parcel/OmGetAllForPrint',
  parcelGetDetailForBarcode: '/v2/Parcel/GetParcelLabels',
  //promotion
  promotionCreate: '/v2/Promotion',
  promotionGetAll: '/v2/Promotion/Search',
  promotionMyList: '/v2/Promotion/GetMyPromotions',
  promotionDelete: (id: string | number) => '/v2/Promotion/' + id,
  getPromotionDetail: (id: string | number) => '/v2/Promotion/' + id,
  promotionUpdate: '/v2/Promotion',
  promotionGetMyList: '/v2/CustomerPromotion/GetMyPromotions',
  parcelInvalidationInvalidateByOrderNumber: '/v2/ParcelInvalidation/InvalidateByOrderNumber',
  parcelInvalidationInvalidateByContractCode: '/v2/ParcelInvalidation/InvalidateByContractCode',
  //pricing
  pricingSegmentsGetAll: '/v2/PackagingGroup/GetAllSegments',
  pricingParcelContentTypeSearch: '/v2/PackagingContent/GetAllParcelContentTypes',
  pricingPackagingTypesSearch: '/v2/PackagingType/GetAllPackagingTypes',
  pricingServicesInRouteSearch: '/v2/Order/GetServicesInRoute',

  //person
  uploadPersonProfilePicture: '/v2/PersonProfilePicture/UploadeProfilePictureForPerson',
  removePersonProfilePicture: (id: number) => '/v2/PersonProfilePicture/RemovePersonProfilePicture/' + id,
  personProfilePicureSearch: '/v2/PersonProfilePicture/Search',

  //province
  provinceGetAll: '/v2/Province/GetAllWithoutSearch',
  //people
  getPeople: '/v2/People/GetFullInfo',
  personEdit: '/v2/People',
  omPersonAcctualEdit: '/v2/People/OmUpdateActualPerson',
  omPersonLegalEdit: '/v2/People/OmUpdateLegalPerson',
  createPeople: '/v2/People',
  addAddressToPeople: '/v2/PeopleAddress',
  getPeopleWithoutCount: '/v2/People/SearchWithoutCount',
  peopleDetail: (id: number | string) => '/v2/people/' + id,
  personBankAccountGetAll: '/v2/personBankAccount/GetCustomerBankAccounts',
  personBankAccountCreate: '/v2/personBankAccount/CreateCustomerBankAccount',
  personBankAccountEdit: '/v2/personBankAccount',
  personBankAccountGetDetail: (id: number | string) => '/v2/personBankAccount/' + id,
  personBankAccountDelete: (id: number | string) => '/v2/personBankAccount/DeleteCustomerBankAccount/' + id,
  personBankAccountsGetAll: '/v2/PersonBankAccount/GetCustomerBankAccounts',
  //packaging
  packagingTypeGetAll: '/v2/PackagingType/PublicGetAll',
  packagingGetAll: '/v2/CustomerPackage/GetMyPackages',
  packagingGetDetail: (id: number | string) => '/v2/CustomerPackage/' + id,
  packagingDelete: (id: number | string) => '/v2/CustomerPackage/BaseSoftDelete/' + id,
  packagingContent: '/v2/PackagingContent/GetAll',
  packagingContentPublic: '/v2/PackagingContent/PublicSearch',
  packagingContentSearch: '/v2/PackagingContent/Search',
  packagingCreate: '/v2/CustomerPackage',
  packageUpdate: '/v2/CustomerPackage',
  packagingGroupGetAll: '/v2/PackagingGroup/Search',
  packagingGroupGetAllPublic: '/v2/PackagingGroup/PublicSearch',
  packagingGroupSearch: '/v2/PackagingGroup/Search',
  packagingTypeGetDetail: (id: number | string) => '/v2/PackagingType/' + id,
  packagingUpdate: '/v2/CustomerPackage',
  parcelUpdatePreOrderOmPanel: '/v2/Parcel/UpdateParcelFromPanel',
  parcelUpdatePreOrderGtetFinancial: '/v2/Parcel/GetFinancialsBeforeUpdateParcel',
  parcelAddressForPreOrder: '/v2/parcel/UpdateParcelAddressForPreOrder',

  //paymentType
  paymentTypeGetAll: '/v2/PaymentType/Search',
  //pickuptype
  pickupTypeGetAll: '/v2/PickupType/Search',
  packagingUnusualType: '/v2/packagingType/PublicGetUnusualPackage',

  //S
  //service
  serviceGetAll: '/v2/Service/Search',
  serviceGetOrderServices: '/v2/Order/OmGetServicesOfOrder',
  serviceTimeWindowGetAll: '/v2/order/GetJetTimeWindows',

  //substation
  substationGetAll: '/v2/Customer/GetMySubstations',
  substationCreate: '/v2/Customer/CreateMySubstation',
  substationDisable: '/v2/Customer/DisableMySubstation',
  substationEnable: '/v2/Customer/EnableMySubstation',

  //T
  //transaction
  transactionGetTotal: '/v2/Transaction/GetTotalBalanceTransaction',
  transactionGetList: '/v2/Transaction/GetMyCustomerTransactions',
  getTransactionType: '/v2/TransactionTypes/Search',
  getAllMyCustomerTransaction: '/v2/Transaction/OmGetAllMyCustomerTransactions',
  //ticket
  ticketDelete: (id: number | string) => '/v2/ticket/' + id,
  ticketGetAll: '/v2/Ticketing/Search',
  ticketGetDetail: (id: number | string) => '/v2/ticket/' + id,
  ticketUpdate: (id: number | string) => '/v2/ticket/' + id,
  ticketCreate: '/v2/Ticketing/CreateTicket',
  ticketCategoryGetAll: '/v2/TicketCategory/GetAll',
  ticketCreateResponse: '/v2/Ticketing/CreateTicketResponse',
  ticketingDetail: '/v2/Ticketing',
  ticketStatusGetList: '/v2/TicketStatuses',
  ticketPriorityGetList: '/v2/TicketPriorities',
  ticketRefer: '/v2/Ticketing/CreateTicketRefer',
  ticketStatusChange: '/v2/Ticketing/ChangeTicketStatus',
  ticketReferClosed: '/v2/Ticketing/ReferClosedTicket',
  ticketChangeCategory: '/v2/Ticketing/ChangeTicketCategory',

  //TermsAndCondition
  checkCustomerTermsAndCondition: '/v2/CustomerTermsAndConditions/CheckTermsAndCondition',
  checkCustomerTermsAndConditionReverseLogestic: (id: string | number) => `/v2/CustomerTermsAndConditions/CheckReverseLogistic?customerId=${id}`,
  acceptTermsAndConditions: '/v2/CustomerTermsAndConditions',
  termsAndConditionsGetAll: '/v2/TermsAndCondition/Search',
  termAndConditionGetDetail: (id: number | string) => '/v2/TermsAndCondition/' + id,

  //U
  //user
  userChangePassword: '/v2/Users/ChangePasswordByUser',
  userActive: '/v2/users/activeuser',
  userRegister: '/v2/users/omregister',
  userFind: '',
  userLogin: '/v2/Users/LoginOmPanel',

  userLoginWithPhoneNumber: '/v2/Users/LoginOmPanelWithPhoneNumber',
  // userLogin: '/v2/Users/Token',
  userWhoAmI: '/v2/Users/WhoAmI',
  userIsAllowedToOrder: '/v2/Users/IsUserAllowedToMakeOrder',
  userByNationalIdGet: '/v2/Users/GetUsersByNationalId',
  usersSearchWithTicketAssignRole: '/v2/Users/SearchAssignTicket',
  userResendCode: '/v2/Users/ResendCode',
  userAccountStatusGet: '/v2/Users/GetUserAccountStatus',
  userChangeGoogleAccountPassword: '/v2/Users/ChangeGoogleAccountPassword',
  userNationalCodeRequiredProvinces: '/v2/NationalCodeRequiredProvinces/CheckNationalCodeIsNeeded',

  //SSO
  userSSORegister: '/v2/Users/SSORegister',
  userSSOValidateUser: '/v2/Users/SSOValidateETipaxUser',
  userSSOResendCode: '/v2/Users/SSOResendCode',
  userLoginSSO: '/v2/Users/LoginSSO',
  userLoginSSOWithUserNameOrPhoneNumber: '/v2/Users/SSOLoginWithUserNameOrPhoneNumber',
  userLoginSSOWithPhoneNumberOtp: '/v2/Users/SSOLoginWithPhoneNumberOtp',
  userLoginGetCodeForOneTimePassword: '/v2/Users/GetCodeForOneTimePassword',
  userLoginWithOneTimePassword: '/v2/Users/LoginWithOneTimePassword',
  userForgetPasswordByPhoneNumber: '/v2/Users/SSOForgotPasswordByPhoneNumber',
  userForgetPasswordByEmailSSO: '/v2/Users/SSOForgotPasswordByEmail',
  userForgetPasswordConfirmationCode: '/v2/Users/SSOForgotPasswordConfirmationCode',
  //w
  //walletRefunf
  walletRefundCreate: '/v2/WalletRefund',
  walletRefundDelete: '/v2/WalletRefund/CancelWalletRefund',
  walletRefundGetAll: '/v2/WalletRefund/GetMyWalletRefund',
  walletRefundStatusGetAll: '/v2/WalletRefundStatus/GetAll',

  //user-WhoAmI
  whoAmI: '/v2/Users/WhoAmI',

  //GISBranches
  nearestBranchBySpecificAddressId: (id: number | string) => '/v2/GisBranches/GetAssingBranchPolygon/' + id,

  //productType
  customerProductList: '/v2/CustomerProduct/Search',
  customerProductDelete: (id: number | string) => '/v2/CustomerProduct/' + id,
  customerProductCreate: '/v2/CustomerProduct',
  customerProductEdit: '/v2/CustomerProduct',
  customerOmGetCustomerCodSettlements: '/v2/Customer/OmGetCustomerCodSettlements',

  //branchCustomerProductType
  getTotalCustomerProducts: '/v2/BranchCustomerProduct/GetTotalCustomerProducts',
  branchCustomerProductList: '/v2/BranchCustomerProduct/GetTotalCustomerProducts',
  branchCustomerProductDelete: (id: number | string) => '/v2/BranchCustomerProduct/BaseSoftDelete/' + id,
  branchCustomerProductCreate: '/v2/BranchCustomerProduct',
  branchCustomerProductEdit: '/v2/BranchCustomerProduct',
};

export default endpointUrls;
